import * as Icons from "../../../../icons";

export function NavbarLinksMobileIcon({
  iconName,
  viewBox = "0 0 24 24",
}: {
  iconName: string;
  viewBox?: string;
}) {
  const Icon = Icons[iconName as keyof typeof Icons];

  return Icon ? <Icon viewBox={viewBox} size={24} /> : null;
}
